import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Icon from '../Icon/Icon';
import { TypeIconName } from '../Icon/tsx';
import Visibility from '../Visibility/Visibility';

export interface Props extends FlexProps {
  /** Name of the icon that appears to the left of the menu item */
  icon?: TypeIconName;
  /** @Ignore */
  onClick?: () => void;
  /** Flag if the menu item should be in a selected state */
  selected?: boolean;
}

/**
 * Dropdown menu items that are the children to the DropdownMenu
 * component.
 */
const DropdownMenuItem: React.FunctionComponent<Props> = (props: Props) => {
  const { children, icon, onClick, selected, ...rest } = props;
  const classes = classnames('DropdownMenu__item', {
    'DropdownMenu__item--selected': selected,
  });

  const handleClick = (event: React.SyntheticEvent) => {
    event.nativeEvent.stopImmediatePropagation();

    if (onClick) {
      onClick();
    }
  };

  return (
    <Flex { ...rest }
        alignChildrenVertical="middle"
        className={ classes }
        direction="horizontal"
        gap="x1"
        onClick={ handleClick }>
      <Visibility Component={ Flex } visible={ selected || false }>
        <Icon name="Tick" />
      </Visibility>

      <Flex
          direction="horizontal"
          gap="x4"
          grow
          initial="none">
        { icon && (
          <Flex>
            <Icon name={ icon } />
          </Flex>
        ) }

        <Flex grow initial="none">
          { children }
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DropdownMenuItem;
